import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">
                韩漫网
              </Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              韩国漫画全集免费在线阅读平台，支持下拉式浏览，让您随时随地畅读好看的韩漫大全。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="Bilibili" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 韩漫网 hanmanwang.com - 韩国漫画全集免费在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}